import { fun_PostAction } from "@/api/index";
// 默认导出
export default {
  // 数据存储对象
  data: () => {
    return {
      // tab切换的name
      activeName: "1",
      // 列表loading状态
      loading: false,
      // 表头按钮组
      btnList: [
        {
          name: "添加",
          type: "success",
          icon: "document-add"
        },
        {
          name: "修改",
          type: "primary",
          icon: "edit"
        },
        {
          name: "删除",
          type: "danger",
          icon: "delete"
        }
      ],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      total: 0, // 总条数
      // 查询表单字段
      form: {
        chineseName: null, // 中文简称
        englishName: null, // 英文简称
        twoCharCode: null, // 两字符代码
        threeCharCode: null, // 三字符代码
        numberCode: null, // 数字代码
      },
      // 查询表单
      formSearchList: [
        {
          type: "input",
          label: "中文简称：",
          value: "chineseName",
          placeholder: "请输入",
          clearable: true
        },
        {
          type: "input",
          label: "英文简称：",
          value: "englishName",
          placeholder: "请输入",
          clearable: true
        },
        {
          type: "input",
          label: "两字符代码：",
          value: "twoCharCode",
          placeholder: "请输入",
          clearable: true
        },
        {
          type: "input",
          label: "三字符代码：",
          value: "threeCharCode",
          placeholder: "请输入",
          clearable: true
        },
        {
          type: "input",
          label: "数字代码：",
          value: "numberCode",
          placeholder: "请输入",
          clearable: true
        },
      ],
      // 表格基础数据
      tableColumns: [
        {
          label: "中文简称",
          prop: "chineseName",
          isShow: true,
        },
        {
          label: "英文简称",
          prop: "englishName",
        },
        {
          label: "两字符代码",
          prop: "twoCharCode",
        },
        {
          label: "三字符代码",
          prop: "threeCharCode",
        },
        {
          label: "数字代码",
          prop: "numberCode",
        },
      ],
      // 表格数据
      tableData: [],
      multipleSelection: [], // 勾选数组
      // 请求路径
      reqUrl: "/nationalNameCode/list",
    };
  },
  // 注册组件
  components: {
  },
  // 模板编译完成
  mounted() {
    // 查询一览数据
    this.fun_GetList();
  },
  // 自定义方法
  methods: {
    /**
     * 获取一览表格数据
     * @author 付翔
     */
    async fun_GetList() {
      try {
        // 打开loading
        this.loading = true;
        // 请求，获取结果集
        let res = await fun_PostAction(this.reqUrl, {
          ...this.form,
          ...this.reqPageData
        });
        // 解构res.data
        const { result, data, msg } = res.data;
        // 判断请求是否成功
        if (result) {
          // 解构data
          const { total, records } = data;
          // 如果是行政区划
          if(this.reqUrl === "/administrativeArea/list"){
                // 遍历数据
                records.map(item=>{
                  item.areaName = item.areaCode + '_' + item.areaName
                })
          }
          // 回显table
          this.tableData = records;
          // 获取分页总条数
          this.total = total;
        } else {
          // 提示请求失败消息
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      } catch {
        // 关闭loading
        this.loading = false;
      }
    },
    /**
     * 查询
     * @author 滕威
     */
    fun_Search() {
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 表头按钮事件
     * @params e 按钮name
     * @author 付翔
     */
    fun_click(e) {
      switch (e) {
        case "添加":
          this.fun_Add();
          break;
        case "修改":
          this.fun_Edit();
          break;
        case "删除":
          this.fun_Del();
          break;
        default:
      }
    },
    /**
     * 勾选事件
     * @params e 选中的数据
     */
    fun_HandleSelectionChange(e) {
      // 将勾选的value值赋给multipleSelection数组
      this.multipleSelection = e;
    },
    /**
     * 查看详情
     * @params e 点击的行数据
     * @author 付翔
     */
    fun_Details(e) {
      // 跳转详情页面
      this.$router.push({
        path: "/nationalNameCodeDetail",
        query: {
          id: this.activeName === "1" ? e.val.id : e.id,
          type: "details",
          activeName: this.activeName,
        }
      });
    },
    /**
     * 点击新增按钮
     */
    fun_Add() {
      // 跳转详情页面
      this.$router.push({
        path: "/nationalNameCodeDetail",
        query: {
          type: "insert",
          activeName: this.activeName,
        }
      });
    },
    /**
     * 点击修改按钮
     */
    fun_Edit() {
      // 判断是否勾选
      if (this.multipleSelection && this.multipleSelection.length > 0){
        // 如果勾选超过1条
        if(this.multipleSelection.length > 1){
          // 提示，并清除选中数据
          this.$alert("只能选择一条数据！", "warning").then(() => {
            // 清除选中数据
            this.$refs.list.$refs.multipleTable.clearSelection();
          });
        }else{
          // 跳转详情页面
          this.$router.push({
            path: "/nationalNameCodeDetail",
            query: {
              type: "update",
              id: this.multipleSelection[0].id,
              activeName: this.activeName,
            }
          });
        }
      }
    },
    /**
     * 删除
     */
    fun_Del(){
      // 判断是否勾选
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        // 主键集合
        let keys = [];
        // 遍历勾选
        for(const index in this.multipleSelection ){
          // 赋值主键集合
          keys[index] = this.multipleSelection[index].id;
        }
        // 弹出询问confirm
        this.$confirm("是否确定删除选中数据？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          // 声明
          var delUrl = "";
          // 判断
          if(this.activeName === "1"){
            // 更换路径
            delUrl = "/nationalNameCode/delete";
          }else{
            // 更换路径
            delUrl = "/administrativeArea/delete";
          }
          // 请求，获取结果集
          fun_PostAction(delUrl, {
            keys: keys
          }).then(res => {
            // 解构res.data
            const { result,msg } = res.data;
            // 判断
            if(result){
              // 操作成功
              this.$message.success(msg);
              // 获取一览表格数据
              this.fun_GetList();
            }else{
              // 提示请求失败消息
              this.$message.error(msg);
            }
          });
        });
      }
      // 如果未进行勾选
      else{
        // 提示，并清除选中数据
        this.$alert("最少选择一条数据！", "warning");
      }
    },
    /**
     * 重置
     * @author 滕威
     */
    fun_Reset() {
      // 清除查询表单
      this.$refs.list.$refs.formItem.map(e => {
        e.resetField();
      });
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 国家代码需要显示的内容
     */
    fun_GetShowCountryCode(){
      // 表头按钮组
      this.btnList = [
        {
          name: "添加",
          type: "success",
          icon: "document-add"
        },
        {
          name: "修改",
          type: "primary",
          icon: "edit"
        },
        {
          name: "删除",
          type: "danger",
          icon: "delete"
        }
      ];
      // 查询表单字段
      this.form = {
        chineseName: null, // 中文简称
        englishName: null, // 英文简称
        twoCharCode: null, // 两字符代码
        threeCharCode: null, // 三字符代码
        numberCode: null, // 数字代码
      };
      // 查询表单
      this.formSearchList = [
        {
          type: "input",
          label: "中文简称：",
          value: "chineseName",
          placeholder: "请输入",
          clearable: true
        },
        {
          type: "input",
          label: "英文简称：",
          value: "englishName",
          placeholder: "请输入",
          clearable: true
        },
        {
          type: "input",
          label: "两字符代码：",
          value: "twoCharCode",
          placeholder: "请输入",
          clearable: true
        },
        {
          type: "input",
          label: "三字符代码：",
          value: "threeCharCode",
          placeholder: "请输入",
          clearable: true
        },
        {
          type: "input",
          label: "数字代码：",
          value: "numberCode",
          placeholder: "请输入",
          clearable: true
        },
      ];
      // 表格基础数据
      this.tableColumns = [
        {
          label: "中文简称",
          prop: "chineseName",
          isShow: true,
        },
        {
          label: "英文简称",
          prop: "englishName",
        },
        {
          label: "两字符代码",
          prop: "twoCharCode",
        },
        {
          label: "三字符代码",
          prop: "threeCharCode",
        },
        {
          label: "数字代码",
          prop: "numberCode",
        },
      ];
    },
    /**
     * 行政区划需要显示的内容
     */
    fun_GetShowDivision(){
      // 表头按钮组
      this.btnList = [
        {
          name: "添加",
          type: "success",
          icon: "document-add"
        },
        {
          name: "修改",
          type: "primary",
          icon: "edit"
        },
        {
          name: "删除",
          type: "danger",
          icon: "delete"
        }
      ];
      // 查询表单字段
      this.form =  {
        areaCode: null, // 行政区域代码
        areaName: null, // 行政区域名称
        parentAreaCode: null, // 上级行政区分代码
        parentAreaName: null, // 上级行政区域名称
        levelNum: null, // 行政级别
      };
      // 查询表单
      this.formSearchList = [
        {
          type: "input",
          label: "行政区域代码：",
          value: "areaCode",
          placeholder: "请输入",
          clearable: true
        },
        {
          type: "input",
          label: "行政区域名称：",
          value: "areaName",
          placeholder: "请输入",
          clearable: true
        },
        {
          type: "input",
          label: "上级行政区域：",
          value: "parentAreaName",
          placeholder: "请输入",
          clearable: true
        },
        {
          type: "select",
          label: "行政级别：",
          value: "levelNum",
          placeholder: "请输入",
          queryParams: {
            url: "/dataDictionaryEntries/DictionaryCombobox",
            zdid: "201507041522510003"
          }
        },
      ];
      // 表格基础数据
      this.tableColumns = [
        {
          label: "上级行政区域",
          prop: "parentAreaName",
        },
        {
          label: "行政区域名称",
          prop: "areaName",
        },
        {
          label: "行政级别",
          prop: "levelName",
        },
        {
          label: "操作",
          slotName: "operation",
        }
      ];
    },
    /**
     * @description 切换tabs
     * @author
     */
     fun_HandleClick(tab, event) {
      // 切换标签页
      this.activeName = tab.name;
      // 如果是国家代码
      if (tab.name === "1") {
        // 显示国家代码
        this.fun_GetShowCountryCode();
        // 更换请求路径
        this.reqUrl = "/nationalNameCode/list";
      } else {
        // 显示行政区划
        this.fun_GetShowDivision();
        // 更换请求路径
        this.reqUrl = "/administrativeArea/list";
      }
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
  }
};
